import { connect } from 'react-redux';

import { SampleAppBar } from '../components/AppBar';

const mapStateToProps = (state) => {
    return Object.assign({}, state.viewerState, state.appState);
};

export default connect(mapStateToProps)(SampleAppBar);
